<template>
  <b-container fluid class="pb-4">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center mb-4">
          <h1 class="fc-h1">{{ $i18n.t("register.title") }}</h1>
          <div class="ml-auto">
            <b-form-checkbox v-model="inputConfirm" name="check-button" switch @change="changeInputConfirm">{{ $i18n.t("register.confirm") }}</b-form-checkbox>
          </div>
        </div>
        <div class="mx-4">
          <div class="row justify-content-center">
            <div class="col">
              <b-form>
                <div class="form-row align-items-end">
                  <div class="col">
                    <b-form-group><label for="fc-point">{{ $i18n.t("register.machineName") }}</label>
                      <b-form-input id="fc-point" disabled v-model="machineName"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group><label for="fc-point-id">{{ $i18n.t("register.machineID") }}</label>
                      <b-input-group>
                        <b-form-input
                          id="fc-point-id"
                          v-model="machineId"
                          v-bind:disabled="machineHold"
                          @keydown.enter="checkInputMachine"
                          ref="inputMachine"
                          :placeholder="this.$i18n.t('register.machineID_placeholder')"
                        ></b-form-input>
                        <b-input-group-append is-text>
                          <b-form-checkbox class v-model="machineHold" @change="changeMachineHold">
                            {{ $i18n.t("register.fix") }}
                            <span class="sr-only">Checkbox for following text input</span>
                          </b-form-checkbox>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="form-row align-items-end">
                  <div class="col">
                    <label>{{ alertMachineMsg }}</label>
                  </div>
                </div>
                <div class="form-row align-items-end">
                  <div class="col">
                    <b-form-group><label for="fc-operator">{{ $i18n.t("register.operator") }}</label>
                      <b-form-input id="fc-operator" disabled v-model="operatorName"></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group><label for="fc-operator-id">{{ $i18n.t("register.operatorID") }}</label>
                      <b-input-group>
                        <b-form-input
                          id="fc-operator-id"
                          v-model="operatorId"
                          v-bind:disabled="operatorHold"
                          @keydown.enter="checkInputOperator"
                          ref="inputOperator"
                          :placeholder="this.$i18n.t('register.operator_placeholder')"
                        ></b-form-input>
                        <b-input-group-append is-text>
                          <b-form-checkbox class v-model="operatorHold" @change="changeOperatorHold">
                            {{ $i18n.t("register.fix") }}
                            <span class="sr-only">Checkbox for following text input</span>
                          </b-form-checkbox>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="form-row align-items-end">
                  <div class="col">
                    <label>{{ alertOpMsg }}</label>
                  </div>
                </div>
                <div class="form-row align-items-end">
                  <div class="col">
                    <b-form-group><label for="fc-product-id">{{ $i18n.t("register.model") }}</label>
                      <b-form-input
                        id="fc-product-id"
                        disabled
                        v-model="proCode"
                      ></b-form-input>
                    </b-form-group>
                  </div>
                  <div class="col">
                    <b-form-group><label for="fc-serial">{{ $i18n.t("register.serial") }}</label>
                      <b-input-group>
                        <b-form-input
                          id="fc-serial"
                          v-model="serial"
                          v-bind:disabled="serialHold"
                          @keydown.enter="checkInputSerial"
                          ref="inputSerial"
                          :placeholder="this.$i18n.t('register.serial_placeholder')"
                        ></b-form-input>
                        <b-input-group-append is-text>
                          <b-form-checkbox class v-model="serialHold" @change="changeSerialHold">
                            {{ $i18n.t("register.fix") }}
                            <span class="sr-only">Checkbox for following text input</span>
                          </b-form-checkbox>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </div>
                </div>
                <div class="form-row align-items-end">
                  <div class="col">
                    <label>{{ alertSerialMsg }}</label>
                  </div>
                </div>
              </b-form>
            </div>

            <template v-if="inputConfirm">
              <div class="col-5">
                <b-form>
                  <b-form-group>
                    <label for="fc-textarea">{{ $i18n.t("register.comment") }}</label>
                    <b-form-textarea
                      id="fc-textarea"
                      v-model="comments"
                      :placeholder="this.$i18n.t('register.comment_placeholder')"
                      rows="3"
                      max-rows="6"
                      ref="inputComment"
                      maxlength="500"
                    ></b-form-textarea>
                  </b-form-group>
                  <div class="row mb-3">
                    <div class="col">
                      <b-button class="fc-btn-register fc-btn-register-ok" @click="register('OK')">OK</b-button>
                    </div>
                    <div class="col">
                      <b-button class="fc-btn-register fc-btn-register-ng" @click="register('NG')">NG</b-button>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <b-input
                      v-model="judge"
                      id="fc-register"
                      size="sm"
                      placeholder="OK/NG"
                      class="fc-input-register"
                      ref="inputJudge"
                      @keydown.enter="inputJudge"
                    ></b-input>
                  </div>
                </b-form>
              </div>
            </template>
          </div>
          <template v-if="registeredFlg">
            <b-card class="mt-5">
              <h2 class="mb-3">{{ $i18n.t("register.register_data") }}</h2>
              <b-table :fields="fields" :items="items" small striped borderless dark responsive></b-table>
            </b-card>
          </template>
        </div>
      </div>
      <div class="col-3 px-4 py-3 fc-side-andon">
        <h2 class="h5 mb-3">{{ $i18n.t("register.result") }}</h2>
        <template v-if="dispProcess1Flg">
          <div class="card mb-3">
            <div class="card-header d-flex align-items-center">
              <div class="text-truncate">{{ dispProcess1Name }}</div>
              <b-button variant="secondary" size="sm" class="ml-1 flex-shrink-1 text-nowrap" @click="editDispProcess(1)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                    fill="#ffffff"
                  />
                </svg>
              </b-button>
              <b-button variant="secondary" size="sm" class="ml-1 flex-shrink-1 text-nowrap" @click="closeProcessResult(1)">×</b-button>
            </div>
            <div class="card-body">
              <div class="fc-side-andon-title">{{ $i18n.t("register.production_count") }}</div>
              <div class="fc-side-andon-text">{{ dispProcess1PassCnt }}</div>
            </div>
          </div>
        </template>
        <template v-if="dispProcess2Flg">
          <div class="card mb-3">
            <div class="card-header d-flex align-items-center">
              <div class="text-truncate">{{ dispProcess2Name }}</div>
              <b-button variant="secondary" size="sm" class="ml-1 flex-shrink-1 text-nowrap" @click="editDispProcess(2)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                    fill="#ffffff"
                  />
                </svg>
              </b-button>
              <b-button variant="secondary" size="sm" class="ml-1 flex-shrink-1 text-nowrap" @click="closeProcessResult(2)">×</b-button>
            </div>
            <div class="card-body">
              <div class="fc-side-andon-title">{{ $i18n.t("register.production_count") }}</div>
              <div class="fc-side-andon-text">{{ dispProcess2PassCnt }}</div>
            </div>
          </div>
        </template>
        <template v-if="dispProcess3Flg">
          <div class="card mb-3">
            <div class="card-header d-flex align-items-center">
              <div class="text-truncate">{{ dispProcess3Name }}</div>
              <b-button variant="secondary" size="sm" class="ml-1 flex-shrink-1 text-nowrap" @click="editDispProcess(3)">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                  <path
                    d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
                    fill="#ffffff"
                  />
                </svg>
              </b-button>
              <b-button variant="secondary" size="sm" class="ml-1 flex-shrink-1 text-nowrap" @click="closeProcessResult(3)">×</b-button>
            </div>
            <div class="card-body">
              <div class="fc-side-andon-title">{{ $i18n.t("register.production_count") }}</div>
              <div class="fc-side-andon-text">{{ dispProcess3PassCnt }}</div>
            </div>
          </div>
        </template>
        <b-button variant="secondary" size="sm" @click="addDispProcess">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
            <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" fill="#ffffff" />
          </svg>
        </b-button>
      </div>
    </div>
    <confirm-modal modId="md-alert" :msg="alertMsg" :titleMsg="titleMsg" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="alertModal"/>
    <InputMachineModal modId="md-inputMachine" :inputMachine="dispProcess" @confirm="inputMachineModal"/>
    <InputMachineModal modId="md-editMachine" :inputMachine="dispProcess" @confirm="editMachineModal"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'
import InputMachineModal from './RegisterInputMachineModal'

export default {
  components: {
    confirmModal,
    InputMachineModal
  },
  created () {
    this.inputConfirm = this.$store.cookieStore.getters.getInputConfirm
    // 製造実績表示
    this.showDispProcess()
    // 製造実績再取得-毎分
    this.intervalId = window.setInterval(this.showDispProcess, 60000)
  },
  destroyed: function () {
    clearInterval(this.intervalId)
  },
  data () {
    return {
      intervalId: undefined,
      alertMsg: '',
      alertMachineMsg: '',
      alertOpMsg: '',
      alertSerialMsg: '',
      titleMsg: '',
      inputConfirm: false,
      machineHold: false,
      operatorHold: false,
      serialHold: false,
      dispProcess1Flg: false,
      dispProcess1Name: '',
      dispProcess1PassCnt: 0,
      dispProcess2Flg: false,
      dispProcess2Name: '',
      dispProcess2PassCnt: 0,
      dispProcess3Flg: false,
      dispProcess3Name: '',
      dispProcess3PassCnt: 0,
      machineId: '',
      machineName: '',
      operatorId: '',
      operatorName: '',
      serial: '',
      proCode: '',
      judge: '',
      comments: '',
      registeredFlg: false,
      dispProcess: '',
      // 0:編集なし、1~3:編集あり(dispProcessKindを設定)
      editDispProcessFlg: 0,
      fields: [
        { key: 'label', label: this.$i18n.t('register.itemName') },
        { key: 'data', label: this.$i18n.t('register.register_data') },
        { key: 'code', label: this.$i18n.t('register.registr_code') }
      ],
      items: [
      ]
    }
  },
  methods: {
    changeInputConfirm: function () {
      this.$store.cookieStore.dispatch('setInputConfirm', !this.inputConfirm)
    },
    changeMachineHold: function () {
      this.$store.store.dispatch('setMachineHold', !this.machineHold)
    },
    changeOperatorHold: function () {
      this.$store.store.dispatch('setOperatorHold', !this.operatorHold)
    },
    changeSerialHold: function () {
      this.$store.store.dispatch('setSerialHold', !this.serialHold)
    },
    editDispProcess: function (dispProcessKind) {
      // 製造実績表示対象編集
      if (dispProcessKind === 1) {
        this.editDispProcessFlg = 1
        this.dispProcess = this.$store.cookieStore.getters.getDispProcess1
      } else if (dispProcessKind === 2) {
        this.editDispProcessFlg = 2
        this.dispProcess = this.$store.cookieStore.getters.getDispProcess2
      } else if (dispProcessKind === 3) {
        this.editDispProcessFlg = 3
        this.dispProcess = this.$store.cookieStore.getters.getDispProcess3
      }
      this.$bvModal.show('md-editMachine')
    },
    addDispProcess: function () {
      // 製造実績表示対象追加
      var dispProcess1 = this.$store.cookieStore.getters.getDispProcess1
      var dispProcess2 = this.$store.cookieStore.getters.getDispProcess2
      var dispProcess3 = this.$store.cookieStore.getters.getDispProcess3
      if (dispProcess1 !== '' && dispProcess2 !== '' && dispProcess3 !== '') {
        this.alertMsg = this.$i18n.t('register.disp_over')
        this.titleMsg = this.$i18n.t('register.title')
        this.$bvModal.show('md-alert')
      } else {
        this.$bvModal.show('md-inputMachine')
      }
    },
    closeProcessResult: function (dispProcessKind) {
      // 製造実績表示対象削除
      if (dispProcessKind === 1) {
        this.dispProcess1Flg = false
        this.$store.cookieStore.dispatch('setDispProcess1', '')
      } else if (dispProcessKind === 2) {
        this.dispProcess2Flg = false
        this.$store.cookieStore.dispatch('setDispProcess2', '')
      } else if (dispProcessKind === 3) {
        this.dispProcess3Flg = false
        this.$store.cookieStore.dispatch('setDispProcess3', '')
      }
    },
    showDispProcess: function () {
      var dispProcess1 = this.$store.cookieStore.getters.getDispProcess1
      var dispProcess2 = this.$store.cookieStore.getters.getDispProcess2
      var dispProcess3 = this.$store.cookieStore.getters.getDispProcess3
      if (dispProcess1 != null && dispProcess1 !== '') {
        this.getProcessResult(dispProcess1, 1)
      } else {
        // dispProcess1の製造実績非表示
        this.$store.cookieStore.dispatch('setDispProcess1', '')
        this.dispProcess1Flg = false
      }

      if (dispProcess2 != null && dispProcess2 !== '') {
        this.getProcessResult(dispProcess2, 2)
      } else {
        // dispProcess2の製造実績非表示
        this.$store.cookieStore.dispatch('setDispProcess2', '')
        this.dispProcess2Flg = false
      }

      if (dispProcess3 != null && dispProcess3 !== '') {
        this.getProcessResult(dispProcess3, 3)
      } else {
        // dispProcess3の製造実績非表示
        this.$store.cookieStore.dispatch('setDispProcess3', '')
        this.dispProcess3Flg = false
      }
    },
    getProcessResult: async function (machine, dispProcessKind) {
      this.titleMsg = this.$i18n.t('common.title_modal_error')
      // shif_masterに登録されている時間で検索
      var dates = await this.getDates()
      var from = window.formatDate(dates.start, 'yyyy-MM-dd')
      var to = window.formatDate(dates.end, 'yyyy-MM-dd')
      var fromTime = window.formatDate(dates.start, 'HH:mm:ss')
      var toTime = window.formatDate(dates.end, 'HH:mm:ss')
      var startStr = this.$moment(from + ' ' + fromTime, 'YYYY-MM-DD HH:mm:00')
      var start = startStr.utc().format('YYYY-MM-DD HH:mm:ss')
      var endStr = this.$moment(to + ' ' + toTime, 'YYYY-MM-DD HH:mm:00')
      var end = endStr.utc().format('YYYY-MM-DD HH:mm:ss')

      // リクエストパラメータ
      var body = {}
      body.machine = machine
      body.start = start
      body.end = end

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      this.$axios
        .post(window.END_POINT + '/state/processResult', body, {
          'headers': headers
        })
        .then(res => {
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              console.log(res.data.message)
              this.alertMsg = this.$i18n.t(res.data.message)
              if (dispProcessKind === 1) {
                this.dispProcess1Flg = false
                this.$store.cookieStore.dispatch('setDispProcess1', '')
              } else if (dispProcessKind === 2) {
                this.dispProcess2Flg = false
                this.$store.cookieStore.dispatch('setDispProcess2', '')
              } else if (dispProcessKind === 3) {
                this.dispProcess3Flg = false
                this.$store.cookieStore.dispatch('setDispProcess3', '')
              }
              this.$bvModal.show('md-alert')
            }
          } else {
            var processInfo = res.data.processInfo
            if (processInfo == null) {
              // 設備情報が未登録
              if (dispProcessKind === 1) {
                this.dispProcess1Flg = false
              } else if (dispProcessKind === 2) {
                this.dispProcess2Flg = false
              } else if (dispProcessKind === 3) {
                this.dispProcess3Flg = false
              }
              this.alertMsg = this.$i18n.t('register.no_machine')
              this.$bvModal.show('md-alert')
            } else {
              // レスポンスを製造実績に反映
              var processName = processInfo.process_name
              var lineName = processInfo.line_name
              var baseName = processInfo.base_name
              var dispProcessName = processName + '/' + lineName + '/' + baseName
              var passCount = processInfo.count
              if (dispProcessKind === 1) {
                // dispProcess1
                this.dispProcess1Flg = true
                this.dispProcess1Name = dispProcessName
                this.dispProcess1PassCnt = passCount
              } else if (dispProcessKind === 2) {
                // dispProcess2
                this.dispProcess2Flg = true
                this.dispProcess2Name = dispProcessName
                this.dispProcess2PassCnt = passCount
              } else if (dispProcessKind === 3) {
                // dispProcess3
                this.dispProcess3Flg = true
                this.dispProcess3Name = dispProcessName
                this.dispProcess3PassCnt = passCount
              }
            }
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log('error')
          console.log(res)
          this.alertMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-alert')
        })
    },
    getDates: async function () {
      var startTime = ''
      var dates = []
      // 開始時間取得
      var reqObj = {}
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      await this.$axios
        .post(window.END_POINT + '/common/selectStartTime', reqObj, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            startTime = res.data.shift_start_time
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
          console.log(res)
        })

      // 日またぎ確認、時間取得
      var nowTime = window.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss')
      dates = window.getStartTime(startTime, nowTime, false)

      return dates
    },
    getSearchDate: function (date, format) {
      if (!format) {
        // デフォルト値
        format = 'YYYY/MM/DD hh:mm:ss'
      }
      // フォーマット文字列内のキーワードを日付に置換する
      format = format.replace(/YYYY/g, date.getFullYear())
      format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2))
      format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2))
      format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2))
      format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2))
      return format
    },
    checkInputMachine: function () {
      // エラーメッセージを空にする
      this.alertMachineMsg = ''

      this.titleMsg = this.$i18n.t('common.title_modal_error')
      if (this.machineId !== '') {
        var headers = {
          'Content-Type': 'application/json',
          'opId': this.$store.store.state.opId,
          'ticketid': this.$store.store.state.ticketId
        }
        // 設備取得
        var body = {}
        console.log('machine' + this.machineId)
        body.machineId = this.machineId
        body.machineIdLikeFlg = '0'
        body.machineName = ''
        body.efFlg = '1'

        document.body.style.overflow = 'hidden'
        this.$store.store.state.loading = true
        this.$axios
          .post(window.END_POINT + '/master/machine/select', body, {
            'headers': headers
          })
          .then(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            console.log(res)
            if (res.data.result !== 'OK') {
              if (res.data.result === '401') {
                // ログインしていない場合
                this.$router.push('/')
              } else {
                // エラー表示
                this.alertMsg = this.$i18n.t(res.data.message)
                this.$bvModal.show('md-alert')
              }
            } else {
              if (res.data.machineInfo.length === 0) {
                // 入力欄を空にする
                this.machineId = ''
                // エラー表示
                this.alertMachineMsg = this.$i18n.t('register.no_machine')
                // this.$bvModal.show('md-alert')
              } else {
                this.machineName = res.data.machineInfo[0].machine_name
                if (this.operatorName === '' && !this.operatorHold) {
                  this.$refs.inputOperator.focus()
                } else if (this.proCode === '' && !this.serialHold) {
                  this.$refs.inputSerial.focus()
                } else {
                  if (!this.inputConfirm) {
                    // 通過履歴登録
                    this.register('OK')
                  } else {
                    this.$refs.inputJudge.focus()
                  }
                }
              }
            }
          })
          .catch(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            console.log('error')
            console.log(res)
            this.alertMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-alert')
          })
      }
    },
    checkInputOperator: function () {
      // エラーメッセージを空にする
      this.alertOpMsg = ''

      this.titleMsg = this.$i18n.t('common.title_modal_error')
      if (this.operatorId !== '') {
        var headers = {
          'Content-Type': 'application/json',
          'opId': this.$store.store.state.opId,
          'ticketid': this.$store.store.state.ticketId
        }
        // オペレータ取得
        var body = {}
        // @マークが含まれている場合メールアドレスで、そうでない場合OP_IDで検索する
        if (this.operatorId.indexOf('@') !== -1) {
          body.opId = ''
          body.mailAddress = this.operatorId
        } else {
          body.opId = this.operatorId
          body.mailAddress = ''
        }
        body.opIdLikeFlg = '0'
        body.mailAddressLikeFlg = '0'
        body.opName = ''
        body.efFlg = '1'

        document.body.style.overflow = 'hidden'
        this.$store.store.state.loading = true
        this.$axios
          .post(window.END_POINT + '/master/operator/select', body, {
            'headers': headers
          })
          .then(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            console.log(res)
            this.titleMsg = this.$i18n.t('common.title_modal_error')
            if (res.data.result !== 'OK') {
              if (res.data.result === '401') {
                // ログインしていない場合
                this.$router.push('/')
              } else {
                // エラー表示
                console.log(res.data.message)
                this.alertMsg = this.$i18n.t(res.data.message)
                this.$bvModal.show('md-alert')
              }
            } else {
              if (res.data.userInfo.length === 0) {
                // 入力欄を空にする
                this.operatorId = ''
                // エラーメッセージ表示
                this.alertOpMsg = this.$i18n.t('register.no_operator')
                // this.$bvModal.show('md-alert')
              } else {
                this.operatorName = res.data.userInfo[0].op_name
                if (this.proCode === '' && !this.serialHold) {
                  this.$refs.inputSerial.focus()
                } else if (this.machineName === '' && !this.machineHold) {
                  this.$refs.inputMachine.focus()
                } else {
                  if (!this.inputConfirm) {
                    // 通過履歴登録
                    this.register('OK')
                  } else {
                    this.$refs.inputJudge.focus()
                  }
                }
              }
            }
          })
          .catch(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            console.log('error')
            console.log(res)
            this.alertMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-alert')
          })
      }
    },
    checkInputSerial: function () {
      // エラーメッセージを空にする
      this.alertSerialMsg = ''

      this.titleMsg = this.$i18n.t('common.title_modal_error')
      if (this.serial !== '') {
        var headers = {
          'Content-Type': 'application/json',
          'opId': this.$store.store.state.opId,
          'ticketid': this.$store.store.state.ticketId
        }
        // 製品情報取得
        var body = {}
        body.serial = this.serial

        document.body.style.overflow = 'hidden'
        this.$store.store.state.loading = true
        this.$axios
          .post(window.END_POINT + '/master/product/select', body, {
            'headers': headers
          })
          .then(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            console.log(res)
            if (res.data.result !== 'OK') {
              if (res.data.result === '401') {
                // ログインしていない場合
                this.$router.push('/')
              } else {
                // 入力欄を空にする
                this.serial = ''
                // エラー表示
                console.log(res.data.message)
                this.alertSerialMsg = this.$i18n.t(res.data.message)
                // this.$bvModal.show('md-alert')
              }
            } else {
              this.proCode = res.data.productInfo.code
              if (this.machineName === '' && !this.machineHold) {
                this.$refs.inputMachine.focus()
              } else if (this.operatorName === '' && !this.operatorHold) {
                this.$refs.inputOperator.focus()
              } else {
                if (!this.inputConfirm) {
                  // 通過履歴登録
                  this.register('OK')
                } else {
                  this.$refs.inputJudge.focus()
                }
              }
            }
          })
          .catch(res => {
            this.$store.store.state.loading = false
            document.body.style.overflow = 'auto'
            console.log('error')
            console.log(res)
            this.alertMsg = this.$i18n.t('common.unexpected_error')
            this.$bvModal.show('md-alert')
          })
      }
    },
    inputJudge: function () {
      this.register(this.judge)
    },
    register: function (judge) {
      this.titleMsg = this.$i18n.t('common.title_modal_error')
      console.log(judge)
      this.titleMsg = this.$i18n.t('common.title_modal_error')
      // 必須チェック
      if (this.machineId === '') {
        this.alertMachineMsg = this.$i18n.t('register.machine_hissu')
        this.$refs.inputMachine.focus()
        // this.$bvModal.show('md-alert')
        return
      }
      if (this.operatorId === '') {
        this.alertOpMsg = this.$i18n.t('register.operator_hissu')
        this.$refs.inputOperator.focus()
        // this.$bvModal.show('md-alert')
        return
      }
      if (this.serial === '') {
        this.alertSerialMsg = this.$i18n.t('register.serial_hissu')
        this.$refs.inputSerial.focus()
        // this.$bvModal.show('md-alert')
        return
      }

      // 入力値確定チェック
      if (this.machineName === '') {
        this.alertMachineMsg = this.$i18n.t('register.machine_enter_error')
        this.$refs.inputMachine.focus()
        // this.$bvModal.show('md-alert')
        return
      }
      if (this.operatorName === '') {
        this.alertOpMsg = this.$i18n.t('register.operator_enter_error')
        this.$refs.inputOperator.focus()
        // this.$bvModal.show('md-alert')
        return
      }
      if (this.proCode === '') {
        this.alertSerialMsg = this.$i18n.t('register.serial_enter_error')
        this.$refs.inputSerial.focus()
        // this.$bvModal.show('md-alert')
        return
      }

      if (this.comments.length > 500) {
        this.alertMsg = this.$i18n.t('register.note_over')
        this.$bvModal.show('md-alert')
        return
      }

      if (judge !== 'OK' && judge !== 'NG') {
        this.alertMsg = this.$i18n.t('register.invalid_barcode')
        this.$bvModal.show('md-alert')
        return
      }

      // 通過履歴登録
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      var body = {}
      body.judge = judge
      body.serial = this.serial
      body.operator = this.operatorId
      body.machine = this.machineId
      body.comments = this.comments

      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/register/pass', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              // エラー表示
              console.log(res.data.message)
              this.alertMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-alert')
            }
          } else {
            var registeredData = [
              {
                label: this.$i18n.t('register.machine'),
                data: this.machineName,
                code: this.machineId
              },
              {
                label: this.$i18n.t('register.operator'),
                data: this.operatorName,
                code: this.operatorId
              },
              {
                label: this.$i18n.t('register.model'),
                data: this.proCode,
                code: this.serial
              },
              {
                label: this.$i18n.t('register.judge'),
                data: judge
              },
              {
                label: this.$i18n.t('register.comment'),
                data: this.comments
              }
            ]
            // 登録データ一旦クリア
            this.items.splice(0)
            // 登録データセット
            this.items.splice(0, 0, ...registeredData)
            // 登録データ表示
            this.registeredFlg = true
            // 入力値クリア
            if (!this.machineHold) {
              this.machineId = ''
              this.machineName = ''
            }
            if (!this.operatorHold) {
              this.operatorId = ''
              this.operatorName = ''
            }
            if (!this.serialHold) {
              this.serial = ''
              this.proCode = ''
            }
            this.comments = ''
            this.judge = ''

            // フォーカス設定
            if (!this.machineHold) {
              this.$refs.inputMachine.focus()
            } else if (!this.operatorHold) {
              this.$refs.inputOperator.focus()
            } else if (!this.serialHold) {
              this.$refs.inputSerial.focus()
            } else if (this.inputConfirm) {
              this.$refs.inputJudge.focus()
            }
            this.showDispProcess()
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log('error')
          console.log(res)
          this.alertMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-alert')
        })
    },
    alertModal: function () {
      this.$bvModal.hide('md-alert')
      this.alertMsg = ''
      this.titleMsg = ''
    },
    inputMachineModal: function () {
      this.$bvModal.hide('md-inputMachine')
      var dispProcess1 = this.$store.cookieStore.getters.getDispProcess1
      var dispProcess2 = this.$store.cookieStore.getters.getDispProcess2
      var dispProcess3 = this.$store.cookieStore.getters.getDispProcess3
      if (dispProcess1 === '') {
        this.$store.cookieStore.dispatch('setDispProcess1', this.dispProcess)
      } else if (dispProcess2 === '') {
        this.$store.cookieStore.dispatch('setDispProcess2', this.dispProcess)
      } else if (dispProcess3 === '') {
        this.$store.cookieStore.dispatch('setDispProcess3', this.dispProcess)
      }
      this.dispProcess = ''
      this.showDispProcess()
    },
    editMachineModal: function () {
      this.$bvModal.hide('md-editMachine')
      if (this.editDispProcessFlg === 1) {
        this.$store.cookieStore.dispatch('setDispProcess1', this.dispProcess)
      } else if (this.editDispProcessFlg === 2) {
        this.$store.cookieStore.dispatch('setDispProcess2', this.dispProcess)
      } else if (this.editDispProcessFlg === 3) {
        this.$store.cookieStore.dispatch('setDispProcess3', this.dispProcess)
      }
      this.dispProcess = ''
      this.editDispProcessFlg = 0
      this.showDispProcess()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fc-h1 {
  padding: 10px 20px;
  font-size: 2rem;
  margin-left: -15px;
}
.fc-btn-register {
  width: 100%;
  height: 8rem;
  font-size: 4rem;
  border-radius: 24px;
  color: black;
  border-width: 2px;
}
.fc-btn-register-ok {
  background: transparent
    linear-gradient(180deg, #8dd9ff 0%, #4dc4ff 10%, #4dc4ff 90%, #3b97ed 100%)
    0% 0% no-repeat padding-box;
}
.fc-btn-register-ng {
  background: transparent
    linear-gradient(180deg, #ffce8e 0%, #f6aa00 10%, #f6aa00 90%, #e88d04 100%)
    0% 0% no-repeat padding-box;
}
.fc-btn-register-ok:hover {
  background: transparent
    linear-gradient(180deg, #74d1ff 0%, #3abcfd 10%, #3abcfd 90%, #2c8feb 100%)
    0% 0% no-repeat padding-box;
}
.fc-btn-register-ng:hover {
  background: transparent
    linear-gradient(180deg, #ffc978 0%, #f39e00 10%, #f39e00 90%, #df8600 100%)
    0% 0% no-repeat padding-box;
}
.fc-btn-register-ok:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 136, 255, 0.3) !important;
}
.fc-btn-register-ng:focus {
  box-shadow: 0 0 0 0.2rem rgba(255, 136, 0, 0.3) !important;
}
.fc-btn-register:active {
  color: black !important;
}
.fc-btn-register-ok:active {
  box-shadow: 0 0 0.2rem 0.3rem rgba(0, 136, 255, 0.4) !important;
}
.fc-btn-register-ng:active {
  box-shadow: 0 0 0.2rem 0.3rem rgba(255, 136, 0, 0.4) !important;
}
.fc-input-register {
  width: 100%;
  text-align: center;
  opacity: 0.5;
  transform: scale(0.6);
}

.fc-side-andon {
  background: rgba(255, 255, 255, 0.05);
  min-height: calc(100vh - 60px);
}
.fc-side-andon .card-header {
  padding: 2px 2px 2px 10px;
}
.fc-side-andon .card-body {
  text-align: center;
  line-height: 1;
}
.fc-side-andon .fc-side-andon-title {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 1rem;
}
.fc-side-andon .fc-side-andon-text {
  font-size: 3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Register.vue